import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Skeleton } from '../../components/ui/skeleton';
import { ArrowsClockwise, Upload, ArrowSquareOut, CircleNotch } from '@phosphor-icons/react';

export function OnChainBalance({ balanceInfo, loading, fetchWalletData }) {
    return (
        <Card className="glass-card mb-6">
            <CardContent className="p-6">
                <div className="flex items-center justify-between">
                    <div>
                        <span className="label-text">ON-CHAIN BALANCE <span className="text-boltz-gold">(DEVNET DEMO)</span></span>
                        {loading ? <Skeleton className="h-8 w-24 mt-2" /> : (
                            <p className="text-2xl font-black font-mono mt-2">
                                {balanceInfo?.onChainBalance?.toFixed(2) || '0.00'}
                                <span className="text-base text-muted-foreground ml-2">Boltz</span>
                            </p>
                        )}
                    </div>
                    <Button variant="outline" onClick={fetchWalletData} data-testid="refresh-balance-btn">
                        <ArrowsClockwise size={18} className="mr-2" />Refresh
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
}

export function MintToWallet({ user, mintAmount, setMintAmount, minting, mintTokens }) {
    return (
        <Card className="glass-card mb-6 border-primary/30">
            <CardHeader><CardTitle className="flex items-center gap-2"><Upload size={20} />Mint to Wallet</CardTitle></CardHeader>
            <CardContent className="space-y-4">
                <p className="text-sm text-muted-foreground">Transfer Boltz from your in-app balance to your Solana wallet on-chain. <span className="text-boltz-gold">Devnet demo &mdash; minting is not live.</span></p>
                <div className="flex gap-3">
                    <div className="flex-1">
                        <Input type="number" step="0.01" min="0" max={user?.boltz_balance || 0} value={mintAmount}
                            onChange={(e) => setMintAmount(e.target.value)} placeholder="Amount to mint"
                            className="font-mono" data-testid="mint-amount-input" />
                    </div>
                    <Button onClick={mintTokens} disabled={minting || !mintAmount} className="btn-primary" data-testid="mint-tokens-btn">
                        {minting ? <CircleNotch size={18} className="animate-spin" /> : <><Upload size={16} className="mr-2" />Mint</>}
                    </Button>
                </div>
                <p className="text-xs text-muted-foreground">Available: {user?.boltz_balance?.toFixed(2) || '0.00'} Boltz</p>
            </CardContent>
        </Card>
    );
}

export function SendBoltz({ user, transferTo, setTransferTo, transferAmount, setTransferAmount, transferring, transferTokens, solanaStatus }) {
    return (
        <Card className="glass-card mb-6 border-cyan-glow/30">
            <CardHeader><CardTitle className="flex items-center gap-2 text-cyan-glow"><ArrowSquareOut size={20} />Send Boltz</CardTitle></CardHeader>
            <CardContent className="space-y-4">
                <p className="text-sm text-muted-foreground">Transfer Boltz to another rider&apos;s Solana wallet. <span className="text-boltz-gold">Devnet demo &mdash; not real value.</span></p>
                <div>
                    <Label htmlFor="transfer-to">Recipient Wallet</Label>
                    <Input id="transfer-to" value={transferTo} onChange={(e) => setTransferTo(e.target.value)}
                        placeholder="Solana wallet address" className="font-mono text-sm" data-testid="transfer-to-input" />
                </div>
                <div className="flex gap-3">
                    <div className="flex-1">
                        <Input type="number" step="0.01" min="0" max={user?.boltz_balance || 0} value={transferAmount}
                            onChange={(e) => setTransferAmount(e.target.value)} placeholder="Amount"
                            className="font-mono" data-testid="transfer-amount-input" />
                    </div>
                    <Button onClick={transferTokens} disabled={transferring || !transferTo || !transferAmount}
                        className="bg-cyan-glow hover:bg-cyan-glow/80 text-black font-display" data-testid="send-rmr-btn">
                        {transferring ? <CircleNotch size={18} className="animate-spin" /> : <><ArrowSquareOut size={16} className="mr-2" />Send</>}
                    </Button>
                </div>
                <p className="text-xs text-muted-foreground">
                    Available: {user?.boltz_balance?.toFixed(2) || '0.00'} Boltz
                    {solanaStatus?.mode === 'live' && <span className="text-neon-green ml-2">On-chain</span>}
                </p>
            </CardContent>
        </Card>
    );
}
